/** Optional event-wire facts shared by both score lists. Missing is never empty. */
export type typeScoreLiveState = {
  possessionTeamId?: string | null;
  summaryLabel?: string;
  downAndDistanceLabel?: string | null;
  baseball?: {
    outs?: number | null;
    isFirstOccupied?: boolean | null;
    isSecondOccupied?: boolean | null;
    isThirdOccupied?: boolean | null;
  } | null;
  football?: {
    ballSpotLabel: string;
    ballSpotPercentFromAway: number;
  } | null;
  /** ISSUE-1393. Only while one hockey team is on a power play. */
  hockey?: {
    powerPlayTeamId: string;
    powerPlayLabel: string;
  } | null;
};

/** ISSUE-1393. The server's "PP" when this team is on a power play, else null. */
export function scorePowerPlayLabel(
  state: typeScoreLiveState | null | undefined,
  teamId: string | null | undefined,
): string | null {
  const hockey = state?.hockey ?? null;
  return hockey !== null && teamId != null && hockey.powerPlayTeamId === teamId
    ? hockey.powerPlayLabel
    : null;
}

/** A completed half must not display runners from its last pitch. */
export function scoreBaseball(state: typeScoreLiveState) {
  const baseball = state.baseball;
  if (baseball == null || baseball.outs === 3) return null;
  const { isFirstOccupied, isSecondOccupied, isThirdOccupied, outs } = baseball;
  const bases: [boolean, boolean, boolean] | null =
    typeof isFirstOccupied === "boolean" &&
    typeof isSecondOccupied === "boolean" &&
    typeof isThirdOccupied === "boolean"
      ? [isFirstOccupied, isSecondOccupied, isThirdOccupied]
      : null;
  return {
    bases,
    outs:
      typeof outs === "number" &&
      Number.isInteger(outs) &&
      outs >= 0 &&
      outs <= 2
        ? outs
        : null,
  };
}

/** Away attacks right; no possession means no directional arrow. No drive is invented. */
export function scoreField(
  state: typeScoreLiveState,
  awayId?: string | null,
  homeId?: string | null,
) {
  const percent = state.football?.ballSpotPercentFromAway;
  if (
    typeof percent !== "number" ||
    !Number.isFinite(percent) ||
    percent < 0 ||
    percent > 100
  )
    return null;
  return {
    x: 10 + percent * 0.8,
    direction:
      state.possessionTeamId != null && state.possessionTeamId === awayId
        ? 1
        : state.possessionTeamId != null && state.possessionTeamId === homeId
          ? -1
          : 0,
  };
}
